import React from 'react';
import { TouchableOpacity } from 'react-native';

interface Props {
  zIndex?: number;
  onPress?: () => void;
}

export function PreventOutsideClick({ zIndex, onPress }: Props) {
  return (
    <TouchableOpacity
      testID="prevent-outside-click"
      style={
        {
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          position: 'fixed',
          zIndex,
        } as any
      }
      onPress={onPress}
    />
  );
}
